'use client'

import { useEffect } from 'react'

import { ensureGtmBooted } from '@/lib/site/gtm-boot'

/**
 * Boots the GTM container as soon as the surface hydrates. Mount via
 * `<GtmRouteScope />` on route groups that want eager tag loading; do not
 * mount directly. Timing matches the previous root-layout
 * `<GoogleTagManager />` mount (post-hydration, `afterInteractive`-class).
 */
export function GtmEagerBoot() {
  useEffect(() => {
    ensureGtmBooted()
  }, [])

  return null
}
